import { Skeleton, TableCell, TableRow, Typography } from '@mui/material';
import React from 'react';

const ScriptLogRowSkeleton = () => {
	return (
		<TableRow>
			<TableCell>
				<Typography>
					<Skeleton width='100%' />
				</Typography>
			</TableCell>
			<TableCell>
				<Typography>
					<Skeleton width='100%' />
				</Typography>
			</TableCell>
		</TableRow>
	);
};

export default ScriptLogRowSkeleton;
